module.exports = __webpack_public_path__ + "static/img/shoes.85c9ead.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/marketplace/shoes.png
// module id = 1110
// module chunks = 1